export { secondaryText } from "./SecondaryText.styles";
export { SecondaryText } from "./SecondaryText";
